import { colors } from "../../Styles";

export function DataLevel({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <rect x="187.76" y="70.69" width="65.94" height="156.92" rx="8.58" ry="8.58"/>
      <rect x="29.76" y="70.69" width="65.94" height="156.92" rx="8.58" ry="8.58"/>
      <path d="M167.63,39.13h-16.33v27.69h14.27l-23.84,34.65-23.83-34.65h14.27v-27.69h-16.33c-6.29,0-11.39,4.28-11.39,9.56v186.07c0,5.28,5.1,9.56,11.39,9.56h51.79c6.29,0,11.39-4.28,11.39-9.56V48.7c0-5.28-5.1-9.56-11.39-9.56Z"/>
    </svg>
  );
}
